import { Vue, Component, Prop } from 'vue-property-decorator';
import { sessionService } from '@/providers/services/auth/session';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { USERS_FILTERS } from '@/utils/roster';
import AssignNewClassLayout from '../m-assign-new-class/m-assign-new-class';
import ConfirmationPullup from '../m-confirmation-pull-up/m-confirmation-pull-up';
import SuccessPullupLayout from '../m-success-pull-up/m-success-pull-up';

@Component({
    name: 'm-create-new-user',
    components: {
        'm-assign-new-class': AssignNewClassLayout,
        'm-confirm-pull-up': ConfirmationPullup,
        'm-success-pull-up': SuccessPullupLayout,
    },
})

export default class CreateNewUSerLayout extends Vue {

    // ----------------------------------------------------------------
    // Properties

    private isAssignClassPullup: boolean = false;

    private isSubmitted: boolean = false;

    private isCreateConfirm: boolean = false;

    private isSuccessPullUp: boolean = false;

    private errorMsg: string = '';

    private isLoading: boolean = false;

    private addUser = {
        firstName: '',
        lastName: '',
        email: '',
        student_id: '',
        userName: '',
        emailOrUsername: '',
    };
    private activeUserType: { name: string, key: string } | any = USERS_FILTERS[1];

    @Prop()
    private classCode: any;

    private isConfirmPullup: boolean = false;
    // ----------------------------------------------------------------
    // Hooks
    // -----------------------------------------------------------------
    // Action
    public validateEmailOrUsername() {
        if (this.addUser.emailOrUsername === '') {
            this.errorMsg = 'The field is required';
        }
        if (this.addUser.emailOrUsername) {
            if (/\@/.test(this.addUser.emailOrUsername)) {
                if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.addUser.emailOrUsername))) {
                    this.errorMsg = '';
                    this.addUser.email = this.addUser.emailOrUsername;
                } else {
                    this.errorMsg = 'The email field must be a valid email';
                }
            } else {
                this.errorMsg = '';
                this.addUser.userName = this.addUser.emailOrUsername;
            }
        }
    }
    private onClose() {
        this.$emit('onClose');
    }

    private onCloseNow() {
        this.$emit('onClose');
    }

    private onNext() {
        this.isSubmitted = true;
        this.$validator.validateAll().then((valid: boolean) => {
            if (this.addUser.emailOrUsername === '') {
                this.errorMsg = 'The field is required';
                return;
            }
            if (this.addUser.emailOrUsername) {
                if (/\@/.test(this.addUser.emailOrUsername)) {
                    if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.addUser.emailOrUsername))) {
                        this.errorMsg = '';
                        this.addUser.email = this.addUser.emailOrUsername;
                    } else if (/\s/.test(this.addUser.emailOrUsername)) {
                        valid = false;
                        this.errorMsg = 'Space is not allowed in email';
                        return;
                    } else {
                        valid = false;
                        this.errorMsg = 'The email field must be a valid email';
                        return;
                    }
                } else if (this.containsSpecialCharacters(this.addUser.emailOrUsername) ||
                /\s/.test(this.addUser.emailOrUsername)) {
                    this.errorMsg = 'Special characters are not allowed in userName.';
                    valid = false;
                    return;
                } else {
                    this.errorMsg = '';
                    this.addUser.userName = this.addUser.emailOrUsername;
                }
            }
            if (valid) {
                if (this.classCode) {
                    this.isConfirmPullup = true;
                } else {
                    this.isAssignClassPullup = true;
                }
            }
        });
    }
    private onClosePullup() {
        this.isConfirmPullup = false;
    }
    private onConfirm() {
        this.createUser();
    }
    private onDismiss() {
        this.isSuccessPullUp = false;
        this.isConfirmPullup = false;
        this.onClose();
        this.$emit('onOverallClose');
    }
    // ------------------------------------------------------------------------
    // Methods
    private createUser(classData?: any) {
        const session: any = sessionService.getSession();
        const userData = {
            first_name: this.addUser.firstName,
            last_name: this.addUser.lastName,
            email: this.addUser.email,
            username: this.addUser.userName,
            roster_global_userid: this.addUser.student_id,
            group_school_id: session.group_school_id,
            user_category: this.activeUserType.key === 'teacher' ? 'teacher' : 'student',
            tenant_id: session.tenant!.tenant_id,
            info: null,
            is_deleted: false,
            is_account_verified: true,
            enable_force_password_change: false,
            login_type: 'credential',
            is_email_verified: true,
        };
        if (classData && classData.code) {
            this.$set(userData, 'class_code', classData.code);
        } else {
            this.$set(userData, 'class_code', this.classCode);
        }
        const payload: any = {
            users: [userData],
        };
        this.isLoading = true;
        adminUtilsAPI.addUser(payload).
        then((data: any) => {
            this.isLoading = false;
            if (classData && data) {
                this.addUser = {
                    firstName: '',
                    lastName: '',
                    email: '',
                    student_id: '',
                    userName: '',
                    emailOrUsername: '',
                };
                this.isSubmitted = false;
                this.isCreateConfirm = true;
            }
            if (this.classCode) {
                this.isSuccessPullUp = true;
            }
        }).catch((error: any) => {
            this.isLoading = false;
            return error;
        });
    }

    private addingUser(classData: any) {
        this.createUser(classData);
        if (!classData) {
            this.onClose();
        }
    }

    private dismissPullup() {
        this.$emit('onOverallClose');
        this.isCreateConfirm = false;
        this.isAssignClassPullup =  false;

    }

    private containsSpecialCharacters(str: any) {
        const regex = /[ !#$%^&*()+\-=\[\]{};':"\\|,<>\/?]/g;
        return regex.test(str);
    }

}
